import { useMemo } from 'react'
import { useLocation } from 'router-v6'
import { REGIONS } from 'v2/configs/constants'
import { protectedRoutes } from 'v2/configs/routes'
import { useAccountDetailsQuery } from 'v2/pages/billing/queries'
import { useInvitedContactsQuery, useViewsQuery } from 'v2/pages/conversations/queries'
import { useSenderIdAccessQuery } from 'v2/pages/settings/phone-numbers/sender-id-queries'
import { useProfileQuery } from 'v2/pages/settings/queries'
import { getLocalAuth, getSessionRoles } from 'v2/utils'
import { useChannelLocks } from './use-channel-locks'
import { useFeatureFlags } from './use-feature-flags'
import { usePermissions } from './use-permissions'

export const useRoutes = () => {
  const { data: views } = useViewsQuery()
  const featureFlags = useFeatureFlags()
  const { data: newConversations } = useInvitedContactsQuery()
  const location = useLocation().pathname
  const { permissions } = usePermissions()
  const { data: profileData } = useProfileQuery()
  const { data: accountDetails } = useAccountDetailsQuery()
  const { hasSenderIdAccess } = useSenderIdAccessQuery()
  // Same hook the pages use, so a ghosted nav item and its page always agree.
  const { isVerifyLocked, isWhatsappLocked, isVerifyAvailable } = useChannelLocks()

  const authDetails = getLocalAuth()
  const isIndianRegion = authDetails.region === REGIONS.IN
  const isUsRegion = authDetails.region === REGIONS.US
  const accountProductType = accountDetails?.account?.account_product_type

  // Read live from localStorage so role updates from useProfileQuery's syncSessionRoles
  // are picked up without requiring a page refresh.
  const roles = getSessionRoles()

  return useMemo(
    () =>
      protectedRoutes({
        featureFlags,
        roles,
        views,
        unassignedCount: newConversations?.length,
        location,
        permissionsMap: permissions,
        profileData,
        isIndianRegion,
        isUsRegion,
        accountProductType,
        hasSenderIdAccess,
        isVerifyLocked,
        isWhatsappLocked,
        isVerifyAvailable,
      }),
    [
      featureFlags,
      roles,
      views,
      newConversations?.length,
      location,
      permissions,
      profileData,
      isIndianRegion,
      isUsRegion,
      accountProductType,
      hasSenderIdAccess,
      isVerifyLocked,
      isWhatsappLocked,
      isVerifyAvailable,
    ],
  )
}
